import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
interface QuizLayoutProps {
  children: React.ReactNode;
  progress?: number;
  onBack?: () => void;
  showBack?: boolean;
  questionNumber?: number;
  totalQuestions?: number;
}
export function QuizLayout({
  children,
  progress,
  onBack,
  showBack = true,
  questionNumber,
  totalQuestions
}: QuizLayoutProps) {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-353">
      {/* Header */}
      <div className="pt-3 pb-2 px-5 sticky top-0 bg-white/90 backdrop-blur-md z-10" data-id="element-354">
        <div className="flex items-center justify-between mb-3" data-id="element-355">
          {showBack ? <button onClick={onBack} className="p-2 -ml-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-50" data-id="element-356">
              <ArrowLeft size={22} data-id="element-357" />
            </button> : <div className="w-10" data-id="element-358" />}

          <div className="flex flex-col items-center" data-id="element-359">
            <div className="font-heading font-bold text-brand text-brand-dark tracking-tight" data-id="element-360">
              Calma en Casa
            </div>
            {questionNumber && totalQuestions && <div className="text-quiz-progress font-medium text-gray-400 mt-0.5" data-id="element-361">
                Pregunta {questionNumber} de {totalQuestions}
              </div>}
          </div>

          <div className="w-10" data-id="element-362" />
        </div>

        {progress !== undefined && <ProgressBar progress={progress} data-id="element-363" />}
      </div>

      {/* Content */}
      <motion.div className="flex-1 flex flex-col px-5 pt-4 pb-4 max-w-lg mx-auto w-full" initial={{
      opacity: 0,
      x: 20
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -20
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} data-id="element-364">
        {children}
      </motion.div>
    </div>;
}